import React from "react";
import { Link } from "react-router-dom";
import { Heart, Eye, Flame } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { money, collectionLabel } from "@/data/site";

export function ProductCard({ product, index = 0, ribbon }) {
  const { toggleWishlist, inWishlist, setQuickView } = useApp();
  const soldOut = product.total_stock === 0;

  return (
    <div className="group relative reveal" style={{ animationDelay: `${(index % 8) * 60}ms` }} data-testid={`product-card-${product.slug}`}>
      <Link to={`/product/${product.slug}`} className="block overflow-hidden bg-ink border border-white/10 transition-colors duration-300 group-hover:border-gold/40">
        <div className="relative aspect-[3/4] overflow-hidden bg-black">
          <img src={product.images?.[0]} alt={product.name} loading="lazy"
            className="h-full w-full object-cover product-img-hover" />
          {product.badge && (
            <span className="absolute left-3 top-3 bg-gold px-2.5 py-1 text-[0.6rem] font-bold uppercase tracking-widest text-black">
              {product.badge}
            </span>
          )}
          {ribbon && (
            <span className="absolute bottom-3 left-3 z-10 flex items-center gap-1 bg-gold px-2 py-1 text-[0.55rem] font-bold uppercase tracking-widest text-black shadow-lg" data-testid={`trending-ribbon-${product.slug}`}>
              <Flame size={10} /> {ribbon}
            </span>
          )}
          {soldOut && (
            <span className="absolute inset-0 flex items-center justify-center bg-black/60 text-xs uppercase tracking-[0.3em] text-cream">Sold Out</span>
          )}
        </div>
      </Link>

      <div className="absolute right-3 top-3 flex flex-col gap-2 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
        <button onClick={() => toggleWishlist(product)} aria-label="Wishlist" data-testid={`wishlist-${product.slug}`}
          className={`flex h-9 w-9 items-center justify-center border backdrop-blur transition ${inWishlist(product.id) ? "border-gold bg-gold text-black" : "border-white/20 bg-black/70 text-cream hover:border-gold hover:text-gold"}`}>
          <Heart size={15} fill={inWishlist(product.id) ? "currentColor" : "none"} />
        </button>
        <button onClick={() => setQuickView(product)} aria-label="Quick view" data-testid={`quickview-${product.slug}`}
          className="flex h-9 w-9 items-center justify-center border border-white/20 bg-black/70 text-cream backdrop-blur transition hover:border-gold hover:text-gold">
          <Eye size={15} />
        </button>
      </div>

      <div className="pt-4">
        <p className="overline-label mb-1 text-[0.6rem]">{collectionLabel(product.collection)}</p>
        <Link to={`/product/${product.slug}`}>
          <h3 className="text-sm font-medium text-cream transition-colors group-hover:text-gold">{product.name}</h3>
        </Link>
        <div className="mt-1.5 flex items-center gap-2">
          <span className="font-mono text-sm text-gold">{money(product.price)}</span>
          {product.previous_price && <span className="font-mono text-xs text-mutedgray line-through">{money(product.previous_price)}</span>}
        </div>
      </div>
    </div>
  );
}
